import { ConfigProvider, ThemeConfig } from "antd";

const assessmentTheme: ThemeConfig = {
  components: {
    Input: {
      borderRadiusLG: 4,
      colorBorder: "#5A57FF",
      colorText: "#E6E6E6",
      colorBgContainer: "#1F1D38",
      colorTextPlaceholder: "#CECDFF",
    },
    Typography: {
      colorText: "#888",
    },
    Select: {
      colorBgContainer: "#1F1D38",
    },
    Radio: {
      colorBgContainer: "transparent",
      colorBorderBg: "#cecdff4d",
      colorBorder: "#cecdff4d",
      buttonBg: "#5A57FF",
      buttonCheckedBg: "#5A57FF",
    },
  },
};

const FreeAssessmentTheme: React.FC<any> = (props) => {
  const { children } = props;
  return <ConfigProvider theme={assessmentTheme}>{children}</ConfigProvider>;
};

export default FreeAssessmentTheme;
